import { render, staticRenderFns } from "./claimrecord.vue?vue&type=template&id=64ae786b&scoped=true&"
import script from "./claimrecord.vue?vue&type=script&lang=ts&"
export * from "./claimrecord.vue?vue&type=script&lang=ts&"
import style0 from "./claimrecord.vue?vue&type=style&index=0&id=64ae786b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ae786b",
  null
  
)

export default component.exports